module.exports = __webpack_public_path__ + "img/box.6b13c4fd.png";